import React from 'react'
import {useTopBanner} from 'contexts/TopBannerContext'
import {motion} from 'motion/react'

/**
 * Component that provides dynamic spacing for the top banner
 * Uses context to automatically adjust height based on banner visibility and scroll state
 * Matches the same spring animation as the banner for perfect synchronization
 */
export const TopBannerSpacer = ({className}: {className?: string}) => {
  const {bannerHeight} = useTopBanner()

  return (
    <motion.div
      className={className}
      style={{
        width: '100%',
        overflow: 'hidden',
        transformOrigin: 'top'
      }}
      initial={{height: bannerHeight}} // Start at current height to prevent CLS
      animate={{
        height: bannerHeight // Height changes: 64 -> 0 -> 64
      }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }}
    />
  )
}
